// Module
var code = "<administration-vendors-grid on-select=\"onVendorSelected($event)\"></administration-vendors-grid>\n";
// Exports
module.exports = code;